import React from "react";
import SocialHero from "../sections/SocialHero";
import { COLORS } from "../utils/constants";
import { Youtube, ArrowRight, Zap, BarChart2 } from "lucide-react";
import { Link } from "react-router-dom";
import { translations, LanguageCode } from "../utils/translations";

interface SocialProps {
  lang?: LanguageCode;
}

const Social: React.FC<SocialProps> = ({ lang = "en" }) => {
  const content = translations[lang].socialPage;

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <SocialHero
        lang={lang}
        title={{
          main: content.heroTitleMain,
          highlight: content.heroTitleHighlight,
        }}
        subtitle={content.heroSubtitle}
        ctaText={content.heroCta}
      />

      {/* Connection to YouTube Features */}
      <section style={{ padding: "24px 6%", backgroundColor: "#F9FAFB" }}>
        <div style={{ maxWidth: "1000px", margin: "0 auto", textAlign: "center" }}>
          <div style={{ 
            display: "inline-flex", 
            alignItems: "center", 
            gap: "8px", 
            padding: "8px 16px", 
            background: "#FF000010", 
            color: "#FF0000", 
            borderRadius: "99px", 
            fontSize: "0.9rem", 
            fontWeight: 700,
            marginBottom: "16px"
          }}>
            <Youtube size={18} /> {content.featuredBadge}
          </div>
          <h2 style={{ fontSize: "2.5rem", fontWeight: 800, color: COLORS.brandPurple, marginBottom: "20px" }}>
            {content.featuredHeading}
          </h2>
          <p style={{ fontSize: "1.1rem", color: "#6B7280", marginBottom: "24px", lineHeight: "1.6" }}>
            {content.featuredIntro}
          </p>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "24px", textAlign: "left" }}>
            <div style={{ padding: "32px", background: "#fff", borderRadius: "20px", border: "1px solid #f0f0f0" }}>
              <div style={{ color: "#FF0000", marginBottom: "16px" }}><Zap size={28} /></div>
              <h3 style={{ fontSize: "1.25rem", fontWeight: 700, marginBottom: "12px" }}>{content.card1Title}</h3>
              <p style={{ color: "#6B7280", fontSize: "0.95rem", lineHeight: "1.5", marginBottom: "20px" }}>
                {content.card1Desc}
              </p>
              <Link to="/#free-tools" style={{ display: "flex", alignItems: "center", gap: "6px", color: COLORS.brandTeal, fontWeight: 700, textDecoration: "none" }}>
                {content.card1Link} <ArrowRight size={16} />
              </Link>
            </div>

            <div style={{ padding: "32px", background: "#fff", borderRadius: "20px", border: "1px solid #f0f0f0" }}>
              <div style={{ color: COLORS.brandTeal, marginBottom: "16px" }}><BarChart2 size={28} /></div>
              <h3 style={{ fontSize: "1.25rem", fontWeight: 700, marginBottom: "12px" }}>{content.card2Title}</h3>
              <p style={{ color: "#6B7280", fontSize: "0.95rem", lineHeight: "1.5", marginBottom: "20px" }}>
                {content.card2Desc}
              </p>
              <Link to="/dashboard" style={{ display: "flex", alignItems: "center", gap: "6px", color: COLORS.brandTeal, fontWeight: 700, textDecoration: "none" }}>
                {content.card2Link} <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section style={{ padding: "32px 6%", textAlign: "center", background: COLORS.brandPurple, color: "#fff" }}>
        <h2 style={{ fontSize: "2.5rem", fontWeight: 800, marginBottom: "24px" }}>{content.ctaTitle}</h2>
        <p style={{ fontSize: "1.2rem", opacity: 0.9, marginBottom: "24px", maxWidth: "600px", margin: "0 auto 24px" }}>
          {content.ctaDesc}
        </p>
        <Link to="/pricing" style={{ 
          background: COLORS.brandTeal, 
          color: "#fff", 
          padding: "16px 40px", 
          borderRadius: "12px", 
          textDecoration: "none", 
          fontWeight: 700, 
          fontSize: "1.1rem",
          display: "inline-block"
        }}>
          {content.ctaBtn}
        </Link>
      </section>
    </div>
  );
};

export default Social;
